export { Preview } from './preview';
export type { ThumbnailVariants } from './preview';

export const PreviewDataStub = [
    {
        id: '0000',
        title: 'Cover',
        thumbnailIsLoading: true,
        isLoading: false,
        content: '<div>0000</div>',
    },
    {
        id: '0000_1',
        title: 'Cover',
        thumbnailIsLoading: false,
        isLoading: false,
        isAdditionalPage: true,
        additionalPageNumber: '1',
        content: '<div>0000</div>',
    },
    {
        id: '1111',
        title: 'Table of Contents',
        pageType: 'TableOfContents',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>1111</div>',
    },
    {
        id: '2222',
        title: 'Profit and Loss',
        pageType: 'PandLPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>2222</div>',
    },
    {
        id: '3333',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>3333</div>',
    },
    {
        id: '4444',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>4444</div>',
    },
    {
        id: '5555',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>5555</div>',
    },
    {
        id: '6666',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>6666</div>',
    },
    {
        id: '7777',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>7777</div>',
    },
    {
        id: '8888',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>8888</div>',
    },
    {
        id: '9999',
        title: 'Balance Sheet',
        pageType: 'BSPage',
        thumbnailIsLoading: true,
        isLoading: true,
        content: '<div>9999</div>',
    },
];

export const PreviewDashboardDataStub = [
    {
        id: '0000',
        title: 'Dashboard',
        thumbnailIsLoading: true,
        isLoading: false,
        content: '<div>0000</div>',
    },
];

function outputText(amount = 25) {
    let textString = ``;
    for (let i = 0; i < amount; i++) {
        textString += `<p>lorem ipsum dolor set</p>`;
    }
    return textString;
}

export const PreviewDashboardPerformanceDataStub = [
    {
        id: 'Performance',
        title: 'Performance Dashboard',
        thumbnailIsLoading: false,
        isLoading: false,
        content: `<div><h1>Performance layout (portrait)</h1></div>
${outputText(70)}
`,
    },
];
